import React from "react"

var Random = {

  generateRandomInteger: function () {
    return (new Date().getTime()) + Math.floor(Math.random() * 1000);
  }

};

module.exports = Random;

export default Random
